import React from 'react';
import SiteLoader from '../../../shared/components/loader/siteLoader';
import { API_CONFIG } from '../../../shared/constants/api';
import httpService from '../../../shared/services/http.services';
import HomeComponent from '../component/home';
import '../component/homeStyle.scss';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            content: null
        };
    }

    componentDidMount = () => {
        this.getHomePageContent();
    };

    /**
     * getHomePageContent method calls home page api
     * it sets data and loading false
     */
    getHomePageContent = async () => {
        try {
            const content = await httpService.get(API_CONFIG.path.home);
            if (content) {
                this.setState({
                    isLoading: false,
                    content: content.acf
                });
            }
          
        } catch (error) {
            console.log(error, 'errro');
        }
    };
    render() {
        return (
            <>
                { this.state.isLoading &&
                    <div className="loadingWrap" >
                        <SiteLoader />
                    </div>
                }
                {/* Home component is rendered initially even if content is null because it is slightly more pretty this way.
                    That is, home component initially has proper height thus the loader is in the middle of the screen and you can not see the footer.
                    Other components are conditionally rendered, making it more ugly but better performance/logic. */}
                <div style={ { opacity: this.state.isLoading ? 0 : 1 } }>
                    <HomeComponent toggle={ this.state.isToggle } content={ this.state.content } />
                </div>
            </>
        );
    }
}

export default Home;